import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class SettingsService {

  public app: any;
  public layout: any;

  constructor() {

    // App Settings
    // -----------------------------------
    this.app = {
      name: 'InComm Payments™. All rights reserved.',
      description: 'InComm DPAM Application',
      year: ((new Date()).getFullYear()),
      complainceDescription:'Disability Act Accessibility Statement',
      complainceLink:'https://www.incomm.com/wp-content/uploads/2022/06/InCommInterimAccessibilityStatementFinalApproved8.3.211.pdf'
    };

    // Layout Settings
    // -----------------------------------
    this.layout = {
      isFixed: true,
      isCollapsed: false,
      isBoxed: false,
      isRTL: false,
      horizontal: false,
      isFloat: false,
      asideHover: false,
      theme: 'D',
      asideScrollbar: false,
      isCollapsedText: false,
      useFullLayout: false,
      hiddenFooter: false,
      offsidebarOpen: false,
      asideToggled: false,
      viewAnimation: 'ng-fadeInUp'
    };

  }
}
